import { useScroll, useSpring, useTransform } from 'motion/react';
import { useRef } from 'react';
export function useArticleHeroAnimation() {
    const containerRef = useRef(null);
    const scroll = useScroll({
        target: containerRef,
        offset: ['start start', 'end start'],
    });
    const scrollYProgress = useSpring(scroll.scrollYProgress, {
        stiffness: 100,
        damping: 25,
        restDelta: 0.001,
    });
    const imageAnimation = {
        paddingLeft: useTransform(scrollYProgress, [0, 0.3], ['5%', '0%']),
        paddingRight: useTransform(scrollYProgress, [0, 0.3], ['5%', '0%']),
    };
    return {
        containerRef,
        imageAnimation,
    };
}
